import { Language } from "./language";

export class ProgrammeInformation {

    constructor(
        public id: number,
        public name: string,
        public language: Language,
        public lviSiteUrl: string,
        public label: string
    ){}
}
